/**
 * The address to render a file's image from.
 *
 * A PDF render of a provider photo (e.g. CompanyCam) uses its downsized
 * `providerPrintSrc` when it has one. The full-size originals are shown at
 * thumbnail size in the PDF anyway, and embedding 163 of them made a 98 MB PDF
 * that Browserless never finished (#23666). Everywhere else — and for any file
 * without a print render — this is just `src`.
 *
 * `file` is typed loosely, like `imageCrossOrigin`, so this works against both
 * the global `paintscout` QuoteFile and the leaner local QuoteFile types.
 */
export function getFileRenderSrc(file: unknown, isPdf: boolean): string | undefined {
  const { src, provider, providerPrintSrc } = (file ?? {}) as {
    src?: string
    provider?: unknown
    providerPrintSrc?: unknown
  }
  // The `typeof` check is the only type guard here: `file` is `unknown`, so dropping it would let a
  // non-string through to `<img src>` with no compile error.
  if (isPdf && provider && typeof providerPrintSrc === 'string' && providerPrintSrc) {
    return providerPrintSrc
  }
  return src
}
